
import type { PropType } from 'vue';
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import BasicButton from '@hems/component/src/buttons/BasicButton.vue';
import Image from '@hems/component/src/image/Image.vue';
import ModalContainer from '@hems/component/src/modal/ModalContainer.vue';
import { localStorageKey } from '@hems/util/src/constant/localStorageKey';
import { getBrowserTimezone, getDateByDateString, getTimezoneDate } from '@hems/util/src/helper/dateHelper';

import type { NoticeInfo } from 'hems/notice';

export default defineComponent({
  name: 'NoticeModal',
  components: {
    ModalContainer,
    Image,
    BasicButton,
  },
  props: {
    noticeInfo: {
      type: Object as PropType<NoticeInfo>,
      required: true,
    },
  },
  emits: ['close'],
  setup(props, { emit }) {
    const { t } = useI18n();

    const getLocalTime = (time: Date) => {
      const timeZone = getBrowserTimezone();
      const dateFormatConfig = { isTime: true, needTimezoneConvert: true, timezone: timeZone };

      return getTimezoneDate(time, dateFormatConfig);
    };

    const noticeTitle = computed(() => props.noticeInfo.title ?? t('code.noticecategory.cd.1'));
    const noticeContents = computed(() => props.noticeInfo.contents ?? t('message.app_undergoing_server_maintenance'));

    const startDate = computed(() =>
      props.noticeInfo.notice_start_dt ? getLocalTime(getDateByDateString(props.noticeInfo.notice_start_dt)) : ''
    );
    const endDate = computed(() =>
      props.noticeInfo.notice_end_dt ? getLocalTime(getDateByDateString(props.noticeInfo.notice_end_dt)) : ''
    );

    const onCloseModal = () => {
      // close 버튼 클릭 시 하루동안 다시 보지 않기 기능 실행
      // 현재 시간 + 1 day의 timestamp를 localStorage에 저장함
      const date = new Date();
      localStorage.setItem(localStorageKey.notice, date.setDate(date.getDate() + 1).toString());
      emit('close');
    };

    return {
      noticeTitle,
      noticeContents,
      startDate,
      endDate,
      onCloseModal,
    };
  },
});
